import React from "react";

export const ExternalLink = ({ page, isBlank, linkText, ...props }) => {
  return (
    <a href={page} target={isBlank ? "_blank" : "_self"} rel="noreferrer">
      {linkText}
    </a>
  );
};
